import { useState } from 'react'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { Popover } from '../popover'
import { Icon } from '../icon'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons'
import { mtc } from '../../../utils/style-helpers'
import { optionButtonStyles } from './styles'

export interface VerticalThreeDotMenuOption {
  key: string
  label: string
  icon?: IconDefinition
  danger?: boolean
}

interface VerticalThreeDotMenuProps {
  options: VerticalThreeDotMenuOption[]
  onSelect: (option: VerticalThreeDotMenuOption) => void
}

export const VerticalThreeDotMenu = ({
  options,
  onSelect,
}: VerticalThreeDotMenuProps) => {
  const [open, setOpen] = useState(false)

  const handleSelect = (option: VerticalThreeDotMenuOption) => {
    onSelect(option)
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <button
          className="p-1 rounded hover:bg-gray-100 text-gray-500 hover:text-gray-700 cursor-pointer"
          aria-label="More options"
        >
          <Icon icon={faEllipsisV} />
        </button>
      </Popover.Trigger>
      <Popover.Content align="end" className="p-1 !w-max !overflow-x-visible">
        {options.map((option) => (
          <button
            key={option.key}
            className={mtc(
              optionButtonStyles(),
              option.danger && 'text-red-100'
            )}
            onClick={() => handleSelect(option)}
          >
            {option.icon && <Icon icon={option.icon} color="text-current" />}
            {option.label}
          </button>
        ))}
      </Popover.Content>
    </Popover>
  )
}
